import React, { useState } from "react";
import {
    MenuItem,
    Nav,
    Navbar,
    NavItem,
    NavDropdown,
    Label,
    Button,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import locale from "locale";
import "./style.less";
import { useEventContext, useUserContext } from "../../context";
import { USER_ROLE } from "../../constant/user";

const isGranted = (action, user) => {
    if (user.role === 'ROLE_ORGANIZATION_EDITOR') {
        return -1 !== ['schedule'].indexOf(action.toLowerCase());
    }

    return true;
}

const EventNavBar = ({ event, user }) => {
    const hasEpisodes = event.stream.reduce((sum, stream) => sum + stream.episode.length, 0) > 0;

    return (
        <Nav>
            {isGranted('eventSettings', user) && (<NavDropdown
                title={locale("mainMenu.eventSettings")}
                id="navbar-event-settings"
            >
                <LinkContainer to={`/event/${event.eventPassword}/event-setting/common`}>
                    <NavItem>{locale('mainMenu.eventSettings.commonSettings')}</NavItem>
                </LinkContainer>
                <LinkContainer to={`/event/${event.eventPassword}/event-setting/branding`}>
                    <NavItem>{locale('mainMenu.eventSettings.brandingSettings')}</NavItem>
                </LinkContainer>
                <LinkContainer to={`/event/${event.eventPassword}/event-setting/authorization`}>
                    <NavItem>{locale('mainMenu.eventSettings.authorization')}</NavItem>
                </LinkContainer>
                <LinkContainer to={`/event/${event.eventPassword}/event-setting/viewing-restriction`}>
                    <NavItem>{locale('mainMenu.eventSettings.viewing-restriction')}</NavItem>
                </LinkContainer>
                {event.moduleMain?.frontendPage === "watch" && (
                    <LinkContainer to={`/event/${event.eventPassword}/event-setting/player-settings`}>
                        <NavItem>{locale('mainMenu.eventSettings.playerSettings')}</NavItem>
                    </LinkContainer>
                )}
                <LinkContainer to={`/event/${event.eventPassword}/event-setting/enabling-modules`}>
                    <NavItem>{locale('mainMenu.eventSettings.enablingModules')}</NavItem>
                </LinkContainer>
            </NavDropdown>)}

            {isGranted('schedule', user) && event.moduleEpisode.enabled && (
                <NavDropdown
                    title={locale("mainMenu.schedule")}
                    id="navbar-menu-schedule"
                >
                    <LinkContainer to={`/event/${event.eventPassword}/episodes`}>
                        <NavItem>{locale("mainMenu.schedule.episodes")}</NavItem>
                    </LinkContainer>
                    {event.moduleEpisode.membersEnabled &&
                        <LinkContainer to={`/event/${event.eventPassword}/participants`}>
                            <NavItem>{locale("mainMenu.schedule.participants")}</NavItem>
                        </LinkContainer>
                    }
                    <LinkContainer
                        to={`/event/${event.eventPassword}/schedule-pdf-constructor`}
                    >
                        <MenuItem>
                            {locale("mainMenu.pdfConstructor")}
                            <Label
                                bsStyle="warning"
                                style={{ marginLeft: '4px' }}
                            >
                                New
                            </Label>
                        </MenuItem>
                    </LinkContainer>
                </NavDropdown>
            )}

            {isGranted('pages', user) && event.moduleBranding.pagesEnabled &&
                <LinkContainer to={`/event/${event.eventPassword}/pages`}>
                    <NavItem>{locale("mainMenu.pages")}</NavItem>
                </LinkContainer>
            }

            {isGranted('widgets', user) && (<NavDropdown
                title={locale("mainMenu.widgets")}
                id="navbar-menu-widgets"
            >
                <LinkContainer
                    to={`/event/${event.eventPassword}/widgets/player`}
                >
                    <MenuItem>
                        {locale("mainMenu.widget.player")}
                    </MenuItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/widgets/broadcast`}
                >
                    <MenuItem>
                        {locale("mainMenu.widget.platform-player")}
                    </MenuItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/widgets/new-registration`}
                >
                    <MenuItem>
                        {locale("mainMenu.widget.registrationConstructor")}
                        <Label
                            bsStyle="warning"
                            style={{ marginLeft: '4px' }}
                        >
                            New
                        </Label>
                    </MenuItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/widgets/program`}
                >
                    <MenuItem>
                        {locale("mainMenu.schedule")}
                        <Label
                            bsStyle="warning"
                            style={{ marginLeft: '4px' }}
                        >
                            New
                        </Label>
                    </MenuItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/widgets/members`}
                >
                    <MenuItem>
                        {locale("mainMenu.schedule.participants")}
                        <Label
                            bsStyle="warning"
                            style={{ marginLeft: '4px' }}
                        >
                            New
                        </Label>
                    </MenuItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/widgets/registration`}
                    className="old-link"
                >
                    <MenuItem>
                        {locale("mainMenu.widget.registration")}
                    </MenuItem>
                </LinkContainer>
            </NavDropdown>)}

            {isGranted('tickets', user) && event.private && (
                <LinkContainer to={`/event/${event.eventPassword}/tickets`}>
                    <NavItem>{locale("mainMenu.tickets")}</NavItem>
                </LinkContainer>
            )}

            {isGranted('accessByEmails', user) && event.moduleAuth.accessByEmails && (
                <LinkContainer
                    to={`/event/${event.eventPassword}/accessByEmails`}
                >
                    <NavItem>{locale("mainMenu.accessByEmails")}</NavItem>
                </LinkContainer>
            )}

            {isGranted('emails', user) && (<NavDropdown
                title={locale("mainMenu.emails")}
                id="navbar-menu-emails"
            >
                <LinkContainer
                    to={`/event/${event.eventPassword}/emailSettings/globalSettings`}
                >
                    <NavItem>
                        {locale("mainMenu.emails.globalSettings")}{" "}
                    </NavItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/emailSettings/blocks`}
                >
                    <NavItem>
                        {locale("mainMenu.emails.blocksEditor")}{" "}
                    </NavItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/emailSettings/constructor`}
                >
                    <NavItem>
                        {locale("mainMenu.emails.lettersConstructor")}{" "}
                    </NavItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/edit-reminders`}
                >
                    <NavItem>
                        {locale("mainMenu.edit.reminders")}{" "}
                    </NavItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/calendar-settings`}
                >
                    <NavItem>
                        Календарь
                    </NavItem>
                </LinkContainer>
            </NavDropdown>)}

            {isGranted('accessPreModeration', user) && (<LinkContainer
                to={`/event/${event.eventPassword}/accessPreModeration`}
            >
                <NavItem>{locale("mainMenu.registrations")}</NavItem>
            </LinkContainer>)}

            {isGranted('interactive', user) && (<NavDropdown
                title={locale("mainMenu.interactive")}
                id="navbar-menu-interctive"
            >
                {event.moduleComment.enabled && (
                    <LinkContainer
                        to={`/event/${event.eventPassword}/interactive/chats`}
                    >
                        <MenuItem>{locale("mainMenu.chats")}</MenuItem>
                    </LinkContainer>
                )}
                {event.moduleQuestion.enabled && (
                    <LinkContainer
                        to={`/event/${event.eventPassword}/interactive/questions`}
                    >
                        <MenuItem>{locale("mainMenu.questions")}</MenuItem>
                    </LinkContainer>
                )}
                <LinkContainer to={`/event/${event.eventPassword}/interactive/pollsAndVoting`}>
                    <NavItem>{locale("mainMenu.interactive.pollsAndVoting")}</NavItem>
                </LinkContainer>
                {event?.moduleQuiz.enabled && (
                    <LinkContainer to={`/event/${event.eventPassword}/interactive/quiz`}>
                        <NavItem>{locale("mainMenu.quizzes")}</NavItem>
                    </LinkContainer>
                )}
                <LinkContainer to={`/event/${event.eventPassword}/interactive/banners`}>
                    <NavItem>{locale("mainMenu.banners")}</NavItem>
                </LinkContainer>
                {event.moduleMain.presence && (
                    <LinkContainer
                        to={`/event/${event.eventPassword}/interactive/presenceCheck`}
                    >
                        <NavItem>{locale("mainMenu.presenceCheck")}</NavItem>
                    </LinkContainer>
                )}
                {event?.moduleShop?.enabled && (
                    <LinkContainer to={`/event/${event.eventPassword}/interactive/shop`}>
                        <NavItem>{locale("mainMenu.shop")}</NavItem>
                    </LinkContainer>
                )}
                <LinkContainer to={`/event/${event.eventPassword}/interactive/eventNotifications`}>
                    <NavItem>{locale("mainMenu.eventNotifications")}</NavItem>
                </LinkContainer>
            </NavDropdown>)}

            {isGranted('statistic', user) && (<NavDropdown
                title={locale("mainMenu.statistic")}
                id="navbar-menu-statistic"
            >
                {user?.role === USER_ROLE.SUPER_ADMIN && (
                    <LinkContainer
                        to={`/event/${event.eventPassword}/statistic`}
                        exact
                    >
                        <NavItem>{locale("mainMenu.statistic.visit")}</NavItem>
                    </LinkContainer>
                )}
                <LinkContainer
                    to={
                        `/event/${event.eventPassword}/statistic/stream/live` +
                        (1 === event.stream.length
                            ? "/" + event.stream[0].streamKey
                            : "")
                    }
                >
                    <NavItem>
                        {locale("mainMenu.statistic.stream.live")}{" "}
                        <Label bsStyle="warning">BETA</Label>
                    </NavItem>
                </LinkContainer>
                <LinkContainer
                    to={
                        `/event/${event.eventPassword}/statistic/stream/record` +
                        (1 === event.stream.length
                            ? "/" + event.stream[0].streamKey
                            : "")
                    }
                >
                    <NavItem>
                        {locale("mainMenu.statistic.stream.record")}{" "}
                        <Label bsStyle="warning">BETA</Label>
                    </NavItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/statistic/polls`}
                >
                    <NavItem>{locale("mainMenu.polls")}</NavItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/statistic/activityTop`}
                >
                    <NavItem>{locale("mainMenu.activityTop")}</NavItem>
                </LinkContainer>
                {event.moduleShop?.enabled && <LinkContainer
                    to={`/event/${event.eventPassword}/statistic/shop`}
                >
                    <NavItem>{locale("mainMenu.statistic.shop")}</NavItem>
                </LinkContainer>}
                <LinkContainer
                    to={`/event/${event.eventPassword}/statistic/notifications`}
                >
                    <NavItem>{locale("mainMenu.notifications")}</NavItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/statistic/banners`}
                >
                    <NavItem>{locale("mainMenu.banners")}</NavItem>
                </LinkContainer>
                <LinkContainer
                    to={`/event/${event.eventPassword}/statistic/download`}
                >
                    <NavItem>{locale("mainMenu.statistic.download")}</NavItem>
                </LinkContainer>
                {event.moduleQuiz?.enabled && (
                    <LinkContainer
                        to={`/event/${event.eventPassword}/statistic/quizzes`}
                    >
                        <NavItem>{locale("mainMenu.quizzes")}</NavItem>
                    </LinkContainer>
                )}
            </NavDropdown>)}

            {isGranted('records', user) && (<LinkContainer to={`/event/${event.eventPassword}/records`}>
                <NavItem>{locale("mainMenu.records")}</NavItem>
            </LinkContainer>)}

            {isGranted('client_certificate', user) && event.moduleMain.clientCertificateEnabled && (
                <NavDropdown
                    title={locale("mainMenu.client_certificate")}
                    id="navbar-menu-clientCertificate"
                >
                    <LinkContainer
                        to={`/event/${event.eventPassword}/client_certificate`}
                        exact
                    >
                        <NavItem>
                            {locale("mainMenu.client_certificate.settings")}
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer
                        to={`/event/${event.eventPassword}/client_certificate/owners`}
                    >
                        <NavItem>
                            {locale("mainMenu.client_certificate.owners")}
                        </NavItem>
                    </LinkContainer>
                </NavDropdown>
            )}

            {isGranted('offline', user) && event.moduleBranding.offlinePageEnabled && (
                <NavDropdown
                    title={locale("mainMenu.offline")}
                    id={"navbar-menu-offline"}
                >
                    <LinkContainer
                        to={`/event/${event.eventPassword}/offline/qr`}
                    >
                        <NavItem>QR код</NavItem>
                    </LinkContainer>
                </NavDropdown>
            )}
        </Nav>
    );
};

const Header = () => {
    const { user } = useUserContext();
    const eventContext = useEventContext();
    const [expanded, setExpanded] = useState(false);
    const event = eventContext?.event;

    const toEventLink = (event) => {
        const appHost = event.client.domain || document.location.hostname;
        const frontendPage = event.moduleMain.frontendPage === 'platform' ? 'event' : 'watch';
        return `${document.location.protocol}//${appHost}/${frontendPage}/${event.eventKey}`;
    }

    let logoutLink = "/logout";
    if (event) {
        logoutLink +=
            `?back=` + encodeURIComponent(`/event/${event.eventPassword}`);
    }
    let logoUrl = "/player/images/comdi/comdi_logo.svg";

    return (
        <Navbar fixedTop fluid onToggle={setExpanded} expanded={expanded} id="cp-nav-bar">
            <Navbar.Header>
                <Navbar.Brand>
                    <LinkContainer
                        to={event ? `/event/${event.eventPassword}` : `/`}
                    >
                        <a>
                            <img src={logoUrl} alt="COMDI" />
                        </a>
                    </LinkContainer>
                </Navbar.Brand>
                <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
                {event && user && <EventNavBar event={event} user={user} />}
                {user && (
                    <Nav pullRight>
                        <NavDropdown title={user.email || ""} id="user-menu">
                            <LinkContainer to={logoutLink}>
                                <NavItem>Выход</NavItem>
                            </LinkContainer>
                        </NavDropdown>
                    </Nav>
                )}
                {event && (
                    <div
                        className="header_button_container"
                    >
                        <Button
                            bsStyle="primary"
                            style={{
                                backgroundColor: `#${event.moduleTheme.accentColor}`,
                                borderColor: `#${event.moduleTheme.accentColor}`,
                            }}
                            href={toEventLink(event)}
                            target="_blank"
                        >
                            К мероприятию
                        </Button>
                    </div>
                )}
            </Navbar.Collapse>
        </Navbar>
    );
};

export default Header;
//export default withRouter(Header);
